goog.provide('el8.ptdata.model.report');


goog.require('el8.appservice.notifier');
goog.require('el8.data.docTags');
goog.require('el8.data.referencedUsers');
goog.require('el8.model.base');
goog.require('el8.ptdata.model.attachment');
goog.require('el8.ptdata.model.externalReportAttachment');
goog.require('el8.ptdata.model.lab');
goog.require('el8.ptdata.model.noteItem');
goog.require('el8.service.tz');
goog.require('el8.service.urls');
goog.require('el8.template.ptdata.reports');
goog.require('el8.uiwidget.deleteConfirm');
goog.require('el8.util.consts');

(function() {

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.makeDocument();
    _class.addDocTags();

    _class.prototype.populate = function(spec) {
        spec = spec || {};

        var forceEmptyStrFn = function(a) { return a || ''; };

        if (spec.note_items) {
            spec.note_items = spec.note_items.map(el8.ptdata.model.noteItem);
        }
        if (spec.doc_tags) {
            el8.data.docTags.create(spec.doc_tags, true);
            this.setDocTagIds(_.pluck(spec.doc_tags, 'id'));
        }
        if (spec.category_names) {
            spec.category_names = spec.category_names ?
                spec.category_names.map(forceEmptyStrFn) : null;
        }
        if (spec.result_grids) {
            var getIdFn = function(a) { return a.id; };
            spec.result_grid_ids = spec.result_grids.map(getIdFn);
        }
        el8_Entity.prototype.populate.call(this, spec);
    };

    _class.addProperty('formCollection', true);

    _class.addStringProperty('reportType');
    _class.addStringProperty('reportTypeName');
    _class.addBoolean('urgent');
    _class.addDateTime('createDate');

    _class.addStringProperty('customTitle', true);

    _class.addProperty('images', false, []);
    _class.addProperty('fullSizeImages', false, []);
    _class.addStringProperty('imageAsPdfUrl');
    _class.addProperty('importedFiles', false, []);
    _class.addIntProperty('fromLetterReceiptId', false);
    _class.addIntProperty('originalDocumentSourceId', false);
    _class.addBoolean('allImagesImported');

    _class.addObservableProperty('noteItems', true, []);
    _class.addIntProperty('reviewUserId');

    _class.addIntProperty('lastManualEditUserId');
    _class.addDate('lastManualEditTime');
    _class.addBoolean('allowManualEdit');

    _class.addProperty('referringAddendumIds', false, []);
    _class.addProperty('referringThreadIds', false, []);
    _class.addModelSetProperty("attachments", el8.ptdata.model.attachment, false, []);
    _class.addModelSetProperty("externalReportAttachments", el8.ptdata.model.externalReportAttachment, false, []);

    /**
     * These properties are for structured reports only
     */
    _class.addStringProperty('printableLabReportUrl');
    _class.addStringProperty('requisitionNumber');
    _class.addBoolean('imaging');
    _class.addDateTime('collectedDate');

    // Indicates whether all results are from the same location, when report has grids
    _class.addBoolean('fromSingleLabLocation');

    // Array of abnormal result names, constructed on server
    _class.addProperty('abnormalResultNames', false, []);

    // Constructed on server (an array)
    _class.addProperty('categoryNames', false, []);

    // Array of abnormal flag dicts {'flag': <flag>, 'description': <description>}
    _class.addProperty('abnormalFlags', false, []);

    _class.addModelSetProperty('resultGrids', el8.ptdata.model.lab.resultGrid, false, []);
    _class.addProperty('resultGridIds', false, []);

    _class.addStringProperty('messagePatientName');
    _class.addDate('messageDob');
    _class.addStringProperty('orderStatus');
    _class.addStringProperty('orderingProviderName');
    _class.addStringProperty('copiesTo');
    _class.addStringProperty('vendorName');
    _class.addStringProperty('displayVendorName');
    _class.addStringProperty('displayReportName');
    _class.addBoolean('txResultOnly');
    _class.addStringProperty('fastingFlag');

    // BiDiLabs Report->Order link: We only expect one, but the relationship is many to many
    // so we'll take latest
    _class.addIntProperty('originatingOrderId');

    /**
     * These properties are client-only, temporary
     */
    // Indicates whether images for report have loaded in report feeds
    _class.addBoolean('imagesLoaded'); // defaults to false

    // Indicates whether images for report have been loaded in chart feed
    _class.addBoolean('chartImagesLoaded'); // defaults to false

    // Indicates whether report addenda, notes, etc. have already been
    // loaded in report feed
    _class.addBoolean('notesLoaded');

    // Helpful methods to manage what is displayed/what isn't
    _class.addBoolean('gridsRendered');

    // propertiesToExclude should include 'resultGrids' if:
    // A. you know you don't need to resultGrids for the template/use in question
    // B. you might be called many times in a row – resultGrids can be expensive to serialize
    _class.prototype.asSoyMap = function(propertiesToExclude) {

        var mapped = el8_Entity.prototype.asSoyMap.call(this, propertiesToExclude);

        delete mapped['isImagesLoaded'];
        delete mapped['isChartImagesLoaded'];
        delete mapped['isNotesLoaded'];
        delete mapped['isGridsRendered'];

        delete mapped['signUserBehalfId'];
        mapped['signUserBehalfName'] = this.getSignUserBehalfName();

        mapped['signUserName'] = this.getSignUserName();

        delete mapped['deleteUserId'];
        mapped['deleteUserName'] = this.getDeleteUserId() ?
            el8.data.referencedUsers.getById(this.getDeleteUserId()).getFullName() : '';

        delete mapped['reviewUserId'];
        mapped['reviewUserName'] = this.getReviewUserName();

        delete mapped['noteItems'];
        mapped['noteItems'] = this.getNoteItems().map(el8.model.toSoyMapFn);

        delete mapped['docTagIds'];
        mapped['docTags'] = this.getDocTagMaps();

        delete mapped['referringAddendumIds'];
        mapped['referringAddendums'] = this.getReferringAddendums().map(el8.model.toSoyMapFn);

        mapped['lastManualEditUserName'] = this.getLastManualEditUserName();

        if (mapped['fromLetterReceiptId']) {
            mapped['fromLetterReceipt'] = this.getFromLetterReceipt().asSoyMap();
        }

        return mapped;

    };

    /**
     * HELPERS -- audit, users
     */
    _class.prototype.getReviewUserName = function() {
        return !this.getReviewUserId() ? '' :
            el8.data.referencedUsers.getById(this.getReviewUserId()).getFullName();
    };
    _class.prototype.getShortResourceName = function() {
        return this.getReportType().toLowerCase();
    };
    _class.prototype.getLastManualEditUserName = function() {
        var personnelId = this.getLastManualEditUserId();
        if (personnelId) {
            var user = el8.data.referencedUsers.getById(personnelId);
            return user ? user.getFullName() : '';
        }
        return '';
    };

    /**
     * HELPERS -- display
     */
    _class.prototype.getDescription = function() {
        return el8.template.ptdata.reports.summary(this.asSoyMap(['resultGrids'])).el8_unescape();
    };
    _class.prototype.getClientGeneratedTitle = function() {
        return el8.template.ptdata.reports.clientGeneratedTitle(
            this.asSoyMap(['resultGrids'])
        ).el8_unescape();
    };
    _class.prototype.getNoteSummary = function() {
        return el8.template.ptdata.reports.noteSummary(this.asSoyMap(['resultGrids'])).el8_unescape();
    };
    _class.prototype.getCardSummary = function() {
        var str = el8.template.ptdata.reports.cardSummary(this.asSoyMap(['resultGrids'])).el8_unescape();
        if (str.length > el8.util.consts.MAX_CARD_SUMMARY_LENGTH) {
            str = str.substring(0, el8.util.consts.MAX_CARD_SUMMARY_LENGTH - 3) + '...';
        }
        return str;
    };
    _class.prototype.getNotifyText = function( type ) {
        if( type === 'SAVE_IN_PROGRESS' ) {
            return 'Signing off report...';
        } else if( type === 'SAVE_COMPLETE' || type === 'MOVED_TO_FEED' ) {
            return 'Report signed off and filed in chart.';
        } else if( type === 'ADD_TO_NOTE' ) {
            return 'Report added to current note (Data).';
        } else if( type === 'ADD_TO_NOTE_HPI' ) {
            return 'Report added to current note (HPI).';
        }
    };

    /**
     * HELPERS -- note items
     */
    _class.prototype.getNoteItemById = function(id) {
        var noteItems = this.getNoteItems();
        for (var i=0; i<noteItems.length; i++) {
            if (noteItems[i].getId() === parseInt(id, 10)) {
                return noteItems[i];
            }
        }
        return null;
    };
    _class.prototype.addNoteItem = function( noteItem ) {
        var result = [ noteItem ];
        if(this.getNoteItems()) {
            result = result.concat(this.getNoteItems());
        }
        result.sort(function(a, b) {
            return a.getId() - b.getId();
        });
        this.setNoteItems(result);
    };
    _class.prototype.removeNoteItem = function( id ) {
        var noteItems = this.getNoteItems();
        var newNoteItems = [];
        for( var i=0; i<noteItems.length; i++ ) {
            if( noteItems[i].getId() !== parseInt(id, 10) ) {
                newNoteItems.push( noteItems[i] );
            }
        }
        this.setNoteItems(newNoteItems);
    };
    _class.prototype.saveNoteItem = function(noteItem, successCb, async) {

        var that = this;

        var id = null;
        var jsonStr = JSON.stringify( noteItem.asMap() );

        // Make call synchronous in order to capture id and return to widget
        $.el8_ajax({
            type: "POST",
            async: (async === true), // defaults to false
            url: el8.service.urls.get('updateReportNoteItem', [that, noteItem.getId()]),
            data: {'noteItem':jsonStr},
            success: function(data) {
                // response has server-assigned id
                noteItem.populate(data);

                // Remove (if exists) and then add back
                that.removeNoteItem( noteItem.getId() );
                that.addNoteItem( noteItem );

                if (successCb) { successCb(noteItem); }
            }
        });

        return id;
    };
    _class.prototype.deleteNoteItem = function( id, callbackFn ) {
        var that = this;
        if(id) {
            $.el8_ajax({
                type: 'DELETE',
                url: el8.service.urls.get('updateReportNoteItem', [that, id]),
                success: function(msg) {
                    that.removeNoteItem(id);
                    if(callbackFn) {
                        callbackFn();
                    }
                }
            });
        }
    };

    /**
     * HELPERS -- addendums, threads
     */
    _class.prototype.getReferringAddendums = function() {
        return el8.ptdata.fetch({
            fetchIds: this.getReferringAddendumIds(),
            patientId: this.getPatientId()
        });
    };
    _class.prototype.getReferringThreads = function() {
        return el8.ptdata.fetch({
            fetchIds: this.getReferringThreadIds(),
            patientId: this.getPatientId()
        });
    };
    _class.prototype.addAddendumId = function(id) {
        var ids = this.getReferringAddendumIds();
        ids.push(id);
        this.setReferringAddendumIds(ids);
    };
    _class.prototype.addThreadId = function(id) {
        var ids = this.getReferringThreadIds();
        ids.push(id);
        this.setReferringThreadIds(ids);
    };

    /**
     * HELPERS -- Images & imported files
     */
    _class.prototype.hasImages = function() {
        return this.getImages().length && this.getFullSizeImages().length;
    };
    _class.prototype.downloadImportedFiles = function() {
        for (var i=0; i<this.getImportedFiles().length; i++) {
            window.open(el8.service.urls.get('downloadImportedFile', [this.getImportedFiles()[i].id]));
        }
    };
    _class.prototype.getFromLetterReceipt = function() {
        var receipt = el8.ptdata.letterReceipts.getById(this.getFromLetterReceiptId());
        if (!receipt) { // sometimes the receipt hasn't been put into the cache yet
            receipt = el8.ptdata.fetch({ fetchId: this.getFromLetterReceiptId(), patientId: this.getPatientId() });
        }
        return receipt;
    };

    _class.prototype.printReport = function() {
        var url;
        if (this.getFromLetterReceiptId() && this.getReportType() === 'consultation' &&
                this.getAttachments().length === 1) {
            // these reports are just a PDF - the normal print form won't work
            var docFileId = this.getAttachments()[0].getPrintableId();
            url = el8.service.urls.get('inlinePdf', [this.getPatientId(), docFileId]);
        } else {
            url = el8.service.urls.get('printReport', [this]);
        }
        if (el8Globals.APP === 'chart') {
            el8.appchart.printService.open({
                attachmentId: this.getId(),
                url: url
            });
        } else {
            window.open(url);
        }
    };

    /**
     * HELPERS -- Saving, deleting, etc.
     */
    _class.prototype.saveSignOff = function(successCb, errorCb) {

        var that = this;
        that.setSignDate(el8.service.tz.now());
        var json = {};
        json['report'] = that.asMap();
        if (that.getResultGridIds()) {
            json['grid_ids'] = that.getResultGridIds();
        }

        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('updateReport', [that]),
            data: JSON.stringify(json),
            success: function(data) {
                el8.ptdata.reports.create(data);
                if(successCb) { successCb(data); }
            },
            error: errorCb
        });
    };
    _class.prototype.assignPatient = function( opts ) {
        var that = this;
        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('changeReportPatient', [that, opts.patientId]),
            success: function(data) {
                var responseObj = data;
                if (responseObj['doReload'] === true) {
                    window.location = el8Globals['PATIENT_PATH']; //window.location.pathname
                } else {
                    el8.ptdata.reports.remove(that.getId(), false); // notify
                    if (opts.successCb) { opts.successCb(); }
                }
            }
        });
    };
    _class.prototype.savePreviousAsPartial = function( prevReportId, callbackFn ) {
        el8.appservice.notifier.notify('Marking previous report as partial...');
        var that = this;
        $.el8_ajax({
            type: 'DELETE',
            url: el8.service.urls.get('removePartialReport', [prevReportId, that.getId()]),
            success: function(data) {

                var responseObj = data;
                el8.appservice.notifier.notify('Previous report marked as partial and removed from chart');

                // Create nonvisit note TODO There's an error here wrt with document is added
                var text = 'Partial / in-progress results for ' + that.getDescription() + ' has been archived.  Click on \"view\" link to see final / completed results';
                el8.appchart.mgr.notes.quickAddNonvisitNote(text, responseObj['finalReport']['id'], function() {
                    if(responseObj['doReload'] === true) {
                        window.location = el8Globals['PATIENT_PATH'];
                    }
                });

                if (callbackFn) { callbackFn(); }

                if (responseObj['doReload'] !== true) {

                    // Update actual report removed by server; should be the same
                    var prevReportId = responseObj['partialReportId'];

                    // Remove partial report, update new report, trigger MERGE event
                    var prevReport = el8.ptdata.reports.getById(prevReportId);
                    el8.ptdata.reports.remove(prevReportId, true); // no notify
                    var updatedReport = el8.ptdata.reports.create(responseObj['finalReport'], true); // no notify
                    el8.ptdata.reports.trigger(EVENTS.MERGED, updatedReport, prevReport);
                }

            }
        });
    };
    _class.prototype.saveMergeReport = function( destinationReportId, callbackFn ) {
        var that = this;

        el8.appservice.notifier.notify('Merging into selected report...');
        var destinationReport = el8.ptdata.reports.getById(destinationReportId);

        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('mergeReports', [that.getId(), destinationReportId]),
            success: function(data) {
                var responseObj = data;
                el8.appservice.notifier.notify('Merged into selected report and original report removed from chart.');

                // Create nonvisit note
                var text = '"' + that.getNoteSummary() + '" has been merged into "' + destinationReport.getNoteSummary() + '."';
                el8.appchart.mgr.notes.quickAddNonvisitNote(text, destinationReportId, function() {
                    if( responseObj['doReload'] === true ) {
                        window.location = el8Globals['PATIENT_PATH']; //window.location.pathname
                    }
                });

                if (callbackFn) { callbackFn(); }

                if(responseObj['doReload'] !== true) {

                    // Remove this report and update destination report (loaded from response)
                    el8.ptdata.reports.remove(that.getId(), true); // no notify
                    var updatedReport = el8.ptdata.reports.create(responseObj['destinationReport'], true); // no notify
                    el8.ptdata.reports.trigger(EVENTS.MERGED, updatedReport, that, true);

                }
            }
        });
    };
    _class.prototype.deleteReport = function(refileImages) {
        var that = this;

        el8.uiwidget.deleteConfirm(
            refileImages ?
                'report and send it back for re-filing' :
                'report',
            function() {
                el8.appservice.notifier.notify('Deleting report...');
                $.el8_ajax({
                    type: 'DELETE',
                    url: el8.service.urls.get('updateReport', [that]) + (refileImages ? '?refile_images=1' : ''),
                    success: function(data) {
                        if (refileImages) {
                            el8.appservice.notifier.notify('Report moved to Unfiled Images in the Fax Inbox');
                        } else {
                            el8.appservice.notifier.notify('Report permanently deleted');
                        }
                        el8.ptdata.reports.remove(that.getId(), false); // notify

                        /**
                         * We want to update affected 'previous 3 lab values' for future
                         * reports. Until we re-work previous labs/upgrade to react, we
                         * are just going to re-fetch everything newer than this object
                         *
                         * NOTE: while generally only lab reports have lab results, it's
                         * possible for other report types to have results, so we'll
                         * be refetching for other report types as well. 99% of the time
                         * this will just mean wasteful API calls, but it does make this
                         * a bit more future-proof if/when we add results to other types
                         */
                        var potentiallyAffectedReports = [];
                        el8.ptdata.reports.allByType(that.getReportType()).forEach(function(r) {
                            if (r.getDocumentDate() >= that.getDocumentDate()) {
                                potentiallyAffectedReports.push(r.getId());
                            }
                        });

                        el8.ptdata.fetch({
                            fetchIds: potentiallyAffectedReports,
                            force: true,
                            async: true,
                            callbackFn: function() {
                                el8.appchart.dialog.reports.refresh(that.getReportType(), false, false); //synchronous feed.update()
                            }
                        });
                    }
                });
            }
        );
    };

    /**
     * HELPERS -- structured grids
     */
    _class.prototype.hasGrids = function() {
        return (this.getResultGrids().length > 0 || this.getResultGridIds().length > 0);
    };
    // This is a hack which should be correct as long as every report has only
    // one vendor (which the server should enforce). The server report model
    // currently only has a vendorName, not a vendor_id on it.
    _class.prototype.getVendorId = function() {
        var resultGrids = this.getResultGrids();
        if (resultGrids) {
            for(var i=0; i<resultGrids.length; i++) {
                var resultsByCategory = resultGrids[i].getResultsByCategory();
                for (var j=0; j<resultsByCategory.length; j++) {
                    var rows = resultsByCategory[j]['rows'];
                    for (var k=0; k<rows.length; k++) {
                        var testCategory = rows[k].getLabTestCategory();
                        if (testCategory && testCategory.getVendorId()) {
                            return testCategory.getVendorId(); //return the first vendor_id we find
                        }
                    }
                }
            }
        }
        return null;
    };
    _class.prototype.getStarredResults = function() {
        var resultGrids = this.getResultGrids();
        var result = [];
        var currStarredRows = null;
        if( resultGrids ) {
            for(var j=0;j<resultGrids.length;j++){
                currStarredRows = resultGrids[j].getStarredResultRows();
                result = result.concat( currStarredRows );
            }
        }
        return result;
    };
    _class.prototype.getResultRow = function(resultId) {
        var resultGrids = this.getResultGrids();
        if( resultGrids ) {
            for( var j=0; j<resultGrids.length; j++ ) {
                if( resultGrids[j].getResultById( resultId ) ) {
                    return resultGrids[j].getResultById( resultId );
                }
            }
        }
        return null;
    };
    _class.prototype.getResultsForTestIds =  function( testIds ) {

        var resultGrids = this.getResultGrids();
        var result = [];

        if (resultGrids) {

            for(var i=0; i<resultGrids.length; i++) {
                var resultsByCategory = resultGrids[i].getResultsByCategory();
                for (var j=0; j<resultsByCategory.length; j++) {
                    var rows = resultsByCategory[j]['rows'];
                    for (var k=0; k<rows.length; k++) {
                        for (var l=0; l<testIds.length; l++) {
                            if (rows[k].getLabTest().getId() === testIds[l]) {
                                result.push(rows[k]);
                                break;
                            }
                        }
                    }
                }
            }
        }
        return result;
    };


    /**
     * HELPERS -- abnormal results
     */
    _class.prototype.getDisplayAbnormalResults = function() {
        return el8.template.ptdata.reports.displayAbnormalResults(this.asSoyMap(['resultGrids'])).el8_unescape();
    };
    _class.prototype.hasAbnormalResults = function() {
        return (this.getAbnormalResultNames().length !== 0);
    };
    // Less reliable for checking for abnormal results, since they only get downloaded
    // when report is requested
    _class.prototype.getAbnormalResults = function() {
        var resultGrids = this.getResultGrids();
        var result = [];
        var currAbnormalRows = null;
        if( resultGrids ) {
            for(var j=0;j<resultGrids.length;j++){
                currAbnormalRows = resultGrids[j].getAbnormalResultRows();
                result = result.concat( currAbnormalRows );
            }
        }
        return result;
    };

    _class.prototype.getExternalReportAttachmentSoyMaps = function() {
        return _.map(this.getExternalReportAttachments(), function(att) {
            return att.asSoyMap(true);
        });
    };

    /**
     * HELPERS -- Patient Forms
     */
    _class.prototype.isStaffReviewAllowed = function() {
        // For https://elationhealth.atlassian.net/browse/RM-45128, we are only updating the feature flag name
        // and not the patient form property because that would involve an expensive migration to go through
        // the json blobs of every existing patient form that has this property
        return this.getFormCollection() && this.getFormCollection().allow_staff_signoff;
    };

    _class.prototype.isSignOffAllowed = function() {
        return el8.data.currUser.isPhysician() || (el8.data.currUser.isOfficeStaff() && this.isStaffReviewAllowed())
    }

    el8.ptdata.model.reportClass = _class;
    el8.ptdata.model.report = function(spec) { return new _class(spec); };

})();
